
import List from "./policylistcomponent";

export default List;
